// src/components/SriLankaPorts.jsx
import React, { useState } from "react";
import mapImage from "./Ports-in-Sri-Lanka.png"; // Update the path if needed
import "../App.css"; // Link to external stylesheet

const portData = [
  {
    name: 'Port of Colombo',
    position: { x: 25, y: 70 }, 
    description: [
      "South Asia’s Maritime center is Colombo Port, which is continually advancing. The port is well linked to East and South Asia, Europe, the Persian Gulf and East Africa where freight originating from or bound to these regions is efficiently serviced.",
      "There are 6 Terminals",
      "🚢Harbor Basin Depth: 18 meters",
      "🚢Entrance Channel Depth: 20 meters",
      "🚢Container Terminal Capacity: ",
      "🚢Each terminal handles up to 2.4 million TEUs annually",
      "🚢Total Capacity: 7.2 million TEUs per year",
      "The Port of Colombo can handle ships up to 18,000 TEUs at the East Container Terminal. It has a 450-meter quay wall and 18-meter water depth. Recently, the MSC MARIELLA, a 24,244 TEU ship, docked there, demonstrating its ability to host large vessels."
    ],
    imageURL: '/images/colombo_harbor.jpg',
    showLabel: false,
  },
  {
    name: 'Port of Hambantota',
    position: { x: 68, y: 88 }, 
    description: [
      "The Hambantota Port, a colloboration between Sri Lanka Ports Authority and China Merchants Port Holdings, is a strategic deep-water facility in Hambantota, Sri Lanka.",
      "🚢It is strategically located on the primary shipping lane connecting Asia and Europe.",
      "🚢The Hambantota International Port in Sri Lanka has a depth of 17 meters.",
      "🚢The harbor features an access channel that is 210 meters wide and 17 meters deep.",
      "🚢It can accommodate up to 33 vessels simultaneously."
    ],
    imageURL: '/images/hambantota-port.jpg',
    showLabel: false,
  },
  {
    name: 'Port of Galle',
    position: { x: 35, y: 90 }, 
    description: [
      "Galle Harbor is a natural harbor situated in Galle, on the southwest coast of Sri Lanka. Presently, Galle port operates as on of the most bustling regional ports in the nation and is the sole port in Sri Lanka offering amenities for recreational yachts.",
      "🚢The Galle Port in Sri Lanka has dredging depth of 3.0 to 6.0 meters (approximately 10 -20 feet).",
      "🚢provide verthing facilities to passenger vessels of 300m in length and cargo vessels of 200m in length which have a depth of 10m and 10.9m "
    ],
    imageURL: '/images/Galle_Port.jpg',
    showLabel: false,
  },
  {
    name: 'Port of Trincomalee',
    position: { x: 62, y: 34 }, 
    description: [
      "Trincomalee Harbor ranks as the second-best natural Harbor globally, boasting approximately ten times the water and land area of the Port of Colombo",
      "Harbor Depth: Water depths within the harbor range from CD -20m to CD -40m.",
      "🚢Access Channel Depth: The access channel has a minimum depth of CD -22.0m.",
      "🚢Navigable Water Depth: The depth of navigable waters within the harbor varies between CD -11.0m and CD -30.0m.",
      "🚢Channel Width: The access channel is 1,554m wide. ",
      "The Port of Trincomalee in Sri Lanka can accommodate vessels with a maximum draft of 13 meters, a maximum length overall (LOA) of 250 meters and a maximum deadweight tonnage (DWT) of 76,037"
    ],
    imageURL: '/images/trincomalee-harbor-1.jpg',
    showLabel: false,
  },
  {
    name: ' Oluvil Port',
    position: { x: 80, y: 53 }, 
    description: [
      "Ampara District has a new commercial harbor, inaugurated in 2013 and constructed in 2008, accommodating vessels up to 5,000 metric tons and over 250 fishing boats",
    ],
    imageURL: '/images/oluvil-port.png',
    showLabel: true,
  },
  {
    name: ' Kankesanthurai',
    position: { x: 32, y: 2 }, 
    description: [
      "Kankesanthurai Port in Sri Lanka, located 56 nautical miles from Karaikal Port in Pondicherry, is undergoing development to accommodate larger vessels at a depth of 30 meters, with plans to dredge for an 8-meter turning basin.",
    ],
    imageURL: '/images/kankasanthure.jpg',
    showLabel: true,
  },
];

const SriLankaPorts = () => {
  const [selectedPort, setSelectedPort] = useState(null);

  const handlePortClick = (port) => {
    if (selectedPort && selectedPort.name === port.name) {
      setSelectedPort(null);
    } else {
      setSelectedPort(port);
    }
  };

  return (
    <>
      <style>{`
        .ports-section {
          display: flex;
          flex-direction: row;
          align-items: flex-start;
          justify-content: center;
          gap: 40px;
          padding: 80px 40px;
          background-image: url('/images/ocean.jpg');
          background-size: cover;
          background-position: center;
          width: 100%;
          min-height: 80vh;
          box-sizing: border-box;
          color: white;
        }

        .map-container {
          position: relative;
          width: 100%;
          max-width: 450px;
          flex-shrink: 0;
          aspect-ratio: 2/3;
        }

        .map-image {
          width: 100%;
          height: 100%;
          object-fit: contain;
          display: block;
        }

        .port-marker {
          position: absolute;
          width: 15px;
          height: 15px;
          border-radius: 50%;
          cursor: pointer;
          transform: translate(-50%, -50%);
          z-index: 10;
          transition: transform 0.3s ease, background-color 0.3s ease;
          border: 2px solid white;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
        }

        .port-marker:hover {
          transform: translate(-50%, -50%) scale(1.3);
          background-color: #ffeb3b !important;
        }

        .port-label {
          position: absolute;
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
          white-space: nowrap;
          font-size: 12px;
          font-weight: 600;
          background: rgba(0, 0, 0, 0.6);
          padding: 2px 8px;
          border-radius: 10px;
          margin-top: 5px;
          pointer-events: none;
        }

        .popup-container {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: white;
          color: #333;
          padding: 20px;
          border-radius: 15px;
          box-shadow: 0 15px 40px rgba(0,0,0,0.4);
          z-index: 100;
          width: 90%;
          max-width: 320px;
          max-height: 80%;
          overflow-y: auto;
          animation: fadeIn 0.3s ease;
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translate(-50%, -45%); }
          to { opacity: 1; transform: translate(-50%, -50%); }
        }

        .popup-container h2 {
          margin: 0 0 15px 0;
          font-size: 20px;
          color: #0b5bef;
        }

        .popup-image {
          width: 100%;
          height: 150px;
          object-fit: cover;
          border-radius: 10px;
          margin-bottom: 15px;
        }

        .popup-description {
          font-size: 13px;
          line-height: 1.5;
          text-align: left;
        }

        .popup-description p {
          margin-bottom: 10px;
        }

        .close-popup-btn {
          margin-top: 15px;
          padding: 8px 20px;
          background: #0b5bef;
          color: white;
          border: none;
          border-radius: 20px;
          cursor: pointer;
          font-size: 14px;
        }

        .text-content {
          max-width: 500px;
        }

        .text-content h2 {
          font-size: 32px;
          margin-bottom: 20px;
          line-height: 1.2;
        }

        .text-content p {
          font-size: 16px;
          line-height: 1.8;
          opacity: 0.9;
        }

        @media (max-width: 1024px) {
          .ports-section {
            padding: 50px 20px;
            gap: 20px;
          }
        }

        @media (max-width: 768px) {
          .ports-section {
            flex-direction: column;
            align-items: center;
            text-align: center;
          }
          .text-content {
            order: -1;
            margin-bottom: 30px;
          }
          .text-content h2 {
            font-size: 24px;
          }
          .text-content p {
            font-size: 14px;
          }
          .map-container {
            max-width: 350px;
          }
        }

        @media (max-width: 480px) {
          .map-container {
            max-width: 300px;
          }
          .port-marker {
            width: 12px;
            height: 12px;
          }
          .port-label {
            font-size: 10px;
          }
        }
      `}</style>
      
      <section className="ports-section" onClick={() => setSelectedPort(null)}>
        <div className="map-container">
          <img src={mapImage} alt="Sri Lanka Ports" className="map-image" />
          
          {portData.map((port, index) => (
            <div
              key={index}
              className="port-marker"
              style={{
                left: `${port.position.x}%`,
                top: `${port.position.y}%`,
                backgroundColor: port.showLabel ? '#2d6ae0' : '#4caf50',
              }}
              onClick={(e) => {
                e.stopPropagation();
                handlePortClick(port);
              }}
              title={port.name}
            >
              {port.showLabel && <span className="port-label">{port.name}</span>}
            </div>
          ))}

          {selectedPort && (
            <div className="popup-container" onClick={(e) => e.stopPropagation()}>
              <h2>{selectedPort.name}</h2>
              <img
                src={selectedPort.imageURL}
                alt={selectedPort.name}
                className="popup-image"
              />
              <div className="popup-description">
                {selectedPort.description.map((item, i) => (
                  <p key={i}>{item}</p>
                ))}
              </div>
              <button className="close-popup-btn" onClick={() => setSelectedPort(null)}>Close</button>
            </div>
          )}
        </div>

        <div className="text-content">
          <h2>Gateway to Global Trade: Sri Lanka's Premier Ports</h2>
          <p className="ports-lead">
            Strategically positioned along the world’s busiest maritime crossroads, Sri Lanka’s major commercial ports — <b>Colombo, Hambantota, Galle, and Trincomalee</b> — serve as indispensable conduits of international commerce, seamlessly bridging global shipping lanes between the East and the West.
          </p>
          <p className="ports-body">
            From the high-volume container terminals and bustling transshipment hub of <b>Colombo</b> to the comprehensive industrial and bunkering capacity at <b>Hambantota</b>, the regional anchorage facilities of <b>Galle</b>, and the expansive deep-water natural harbor of <b>Trincomalee</b>, each port delivers exceptional turnaround efficiency, reliability, and full-scale engineering support. Embrace the strategic advantages of Sri Lanka's premier maritime gateways.
          </p>
        </div>
      </section>
    </>
  );
};

export default SriLankaPorts;